export const defaultParams = {
  kong: {
    body: null,
    weapon: null,
    shield: null,
    armor: null,
    hat: null,
    position: [0, 0],
    rotation: 0,
    equipments: [],
  },
  text: {
    active: false,
    value: '',
    font: null,
    size: 2,
    position: [0, 2.5, -3],
    color: 0xffffff,
  },
  arena: null,
  color: 0xfd0548,
  animation: null,
  autoResize: true,
  controlsDisabled: false,
  parallaxDisabled: false,
  rainDisabled: false,
  particlesDisabled: false,
  transparentBg: false,
  zoomDisabled: false,
  panDisabled: false,
  auraEnabled: false,
  cameraZoom: 0,
  cameraPosition: [0, 0, 0],
};
